import { css } from 'linaria';
import { styled } from 'linaria/react';

export const BannerBlock = styled.div`
  position: relative;
  width: 100%;
`;

export const bannerImg = css`
  & img {
    width: 100%;
    object-fit: scale-down;
  }
`;

export const adBadge = css`
  position: absolute;
  left: var(--space-100);
  bottom: var(--space-100);
`;
